import React from "react";
import MasterData from "view/settings/masterdata/MasterData";

const RailRevenueLeasing = () => {
    
    const sections = [
        { label: "Status", value: "Status", items: [] },
    ];

    return (
        <MasterData pageTitle="Rail" sections={sections} />
    );
};

export default RailRevenueLeasing;